/**
 * @generated SignedSource<<d2cee26b7663287c8321469996d018f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueFetchQueryVariables$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly fieldSetId: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "IssueFetchQueryVariables";
};
export type IssueFetchQueryVariables$key = {
  readonly " $data"?: IssueFetchQueryVariables$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFetchQueryVariables">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueFetchQueryVariables",
  "selections": [
    {
      "concreteType": "JiraIssueSearchFieldSetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssueSearchFieldSet",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fieldSetId"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};

(node as any).hash = "23fe80fc33e4a75a483fe224b74c4665";

export default node;
